import {MoneyType} from "app/types/common";
import IDRtoppayOptions from "../bank/IDRtoppayOptions";
import MXNbpayOptions from "../bank/MXNbpayOptions";
import MXNbilhubOptions from "../bank/MXNbilhubOptions";
import MYRtarspayOptions from "../bank/MYRtarspayOptions";
import NGNngpayOptions from "../bank/NGNngpayOptions";
import NGNbpayOptions from "../bank/NGNbpayOptions";
import VNDvndpayOptions from "../bank/VNDvndpayOptions";
import {IDRcoverpayBranchCodeOptionsCard, IDRcoverpayBranchCodeOptionsEWallet} from "../bank/IDRcoverpayBranchCodeOptionsCard";
import INRaepayOptions from "../bank/INRaepayOptions";
import ZARppayOptions from "../bank/ZARppayOptions";
import INRmetagopayOptions from "../bank/INRmetagopayOptions";
import SGDbankcardOptions from "../bank/SGDbankcardOptions";
import ZARbpayOptions from "../bank/ZARbpayOptions";

export const pixTypeTransafeReg = {
    CPF: /^\d{11}$/,
    CNPJ: /^\d{14}$/,
    EMAIL: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
    PHONE: /^\d{10,11}$/,
    EVP: /^[0-9 a-z]{8}-[0-9 a-z]{4}-[0-9 a-z]{4}-[0-9 a-z]{4}-[0-9 a-z]{12}$/,
    IFSC: /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{11}$/,
};

export type Field = {
    type: "input" | "select" | "phone";
    name: string;
    label: string;
    options?: Array<{label: string; value: string}>;
    ifShow?: {field: string; value: string};
    ifHidden?: {field: string; value: string};
    pattern?: RegExp;
    extra?: string;
    showSearch?: boolean;
};

export type CurrencyConfigType = {
    type: number;
    deposit: Record<string, Array<Field>>;
    withdraw: Record<string, Array<Field>>;
};

export const CurrencyConfig: CurrencyConfigType[] = [
    {
        type: MoneyType.BRL,
        deposit: {
            astropaydir: [
                {
                    type: "phone",
                    name: "phone",
                    label: "PhoneAccount",
                    pattern: pixTypeTransafeReg.PHONE,
                },
                {type: "input", name: "payeeFirstName", label: "PayeeFirstName"},
                {type: "input", name: "payeeLastName", label: "PayeeLastName"},
                {type: "input", name: "paymentMethod", label: "CPFAccount", pattern: pixTypeTransafeReg.CPF},
            ],
            transafe: [
                {type: "input", name: "paymentMethod", label: "CPFAccount", pattern: pixTypeTransafeReg.CPF},
                {type: "input", name: "customerName", label: "UserName"},
            ],
            betcatnew: [
                {type: "input", name: "paymentMethod", label: "CPFAccount", pattern: pixTypeTransafeReg.CPF},
                {type: "input", name: "customerName", label: "UserName"},
            ],
            betcatpay: [
                {type: "input", name: "paymentMethod", label: "CPFAccount", pattern: pixTypeTransafeReg.CPF},
                {type: "input", name: "customerName", label: "UserName"},
            ],
        },
        withdraw: {
            hkppay: [
                {
                    type: "select",
                    name: "branchCode",
                    label: "BankCode",
                    options: [
                        {label: "CPF", value: "PIX_CPF"},
                        {label: "PHONE", value: "PIX_PHONE"},
                        {label: "EMAIL", value: "PIX_EMAIL"},
                        {label: "CNPJ", value: "PIX_CNPJ"},
                    ],
                },
                {type: "input", name: "payeeName", label: "payeeName"},
                {
                    type: "input",
                    name: "payeeAccountNo",
                    label: "EmailAccount",
                    pattern: pixTypeTransafeReg.EMAIL,
                    ifShow: {field: "branchCode", value: "PIX_EMAIL"},
                },
                {
                    type: "phone",
                    name: "payeeAccountNo",
                    label: "PhoneAccount",
                    pattern: pixTypeTransafeReg.PHONE,
                    ifShow: {field: "branchCode", value: "PIX_PHONE"},
                },
                {type: "input", name: "payeeAccountNo", label: "CPFAccount", pattern: pixTypeTransafeReg.CPF, ifShow: {field: "branchCode", value: "PIX_CPF"}},
                {
                    type: "input",
                    name: "payeeAccountNo",
                    label: "CNPJAccount",
                    pattern: pixTypeTransafeReg.CNPJ,
                    ifShow: {field: "branchCode", value: "PIX_CNPJ"},
                },
            ],
            cashpay: [
                {
                    type: "select",
                    name: "payeeAccountType",
                    label: "BankCode",
                    options: [
                        {label: "EMAIL", value: "1"},
                        {label: "PHONE", value: "2"},
                        {label: "CPF", value: "3"},
                        {label: "CNPJ", value: "4"},
                        {label: "RANDOM", value: "5"},
                    ],
                },
                {type: "input", name: "payeeIdNumber", label: "IdCard"},
                {
                    type: "input",
                    name: "payeeAccountNo",
                    label: "EmailAccount",
                    pattern: pixTypeTransafeReg.EMAIL,
                    ifShow: {field: "payeeAccountType", value: "1"},
                },
                {
                    type: "phone",
                    name: "payeeAccountNo",
                    label: "PhoneAccount",
                    pattern: pixTypeTransafeReg.PHONE,
                    ifShow: {field: "payeeAccountType", value: "2"},
                },
                {type: "input", name: "payeeAccountNo", label: "CPFAccount", pattern: pixTypeTransafeReg.CPF, ifShow: {field: "payeeAccountType", value: "3"}},
                {
                    type: "input",
                    name: "payeeAccountNo",
                    label: "CNPJAccount",
                    pattern: pixTypeTransafeReg.CNPJ,
                    ifShow: {field: "payeeAccountType", value: "4"},
                },
            ],
            betcatpay: [
                {
                    type: "select",
                    name: "payeeAccountType",
                    label: "BankCode",
                    options: [
                        {label: "CPF", value: "1"},
                        {label: "CNPJ", value: "2"},
                        {label: "PHONE", value: "3"},
                        {label: "EMAIL", value: "4"},
                    ],
                },
                {type: "input", name: "payeeName", label: "UserName"},
                {type: "input", name: "payeeAccountNo", label: "CPFAccount", pattern: pixTypeTransafeReg.CPF, ifShow: {field: "payeeAccountType", value: "1"}},
                {
                    type: "input",
                    name: "payeeAccountNo",
                    label: "CNPJAccount",
                    pattern: pixTypeTransafeReg.CNPJ,
                    ifShow: {field: "payeeAccountType", value: "2"},
                },
                {
                    type: "phone",
                    name: "payeeAccountNo",
                    label: "PhoneAccount",
                    pattern: pixTypeTransafeReg.PHONE,
                    ifShow: {field: "payeeAccountType", value: "3"},
                },
                {
                    type: "input",
                    name: "payeeAccountNo",
                    label: "EmailAccount",
                    pattern: pixTypeTransafeReg.EMAIL,
                    ifShow: {field: "payeeAccountType", value: "4"},
                },
                {
                    type: "input",
                    name: "issuerCode",
                    label: "CPFNumber",
                    pattern: pixTypeTransafeReg.CPF,
                    ifHidden: {field: "payeeAccountType", value: "1"},
                    extra: "payeeAccountNo",
                },
            ],
            transafe: [
                {
                    type: "select",
                    name: "branchCode",
                    label: "BankCode",
                    options: [
                        {label: "CPF", value: "PIX_CPF"},
                        {label: "CNPJ", value: "PIX_CNPJ"},
                        {label: "PHONE", value: "PIX_PHONE"},
                        {label: "EMAIL", value: "PIX_EMAIL"},
                        {label: "EVP", value: "PIX_EVP"},
                    ],
                },
                {type: "input", name: "payeeName", label: "UserName"},
                {type: "input", name: "payeeAccountNo", label: "CPFAccount", pattern: pixTypeTransafeReg.CPF, ifShow: {field: "branchCode", value: "PIX_CPF"}},
                {
                    type: "input",
                    name: "payeeAccountNo",
                    label: "CNPJAccount",
                    pattern: pixTypeTransafeReg.CNPJ,
                    ifShow: {field: "branchCode", value: "PIX_CNPJ"},
                },
                {
                    type: "phone",
                    name: "payeeAccountNo",
                    label: "PhoneAccount",
                    pattern: pixTypeTransafeReg.PHONE,
                    ifShow: {field: "branchCode", value: "PIX_PHONE"},
                },
                {
                    type: "input",
                    name: "payeeAccountNo",
                    label: "EmailAccount",
                    pattern: pixTypeTransafeReg.EMAIL,
                    ifShow: {field: "branchCode", value: "PIX_EMAIL"},
                },
                {
                    type: "input",
                    name: "payeeAccountNo",
                    label: "EVPAccount",
                    pattern: pixTypeTransafeReg.EVP,
                    ifShow: {field: "branchCode", value: "PIX_EVP"},
                },
                {
                    type: "phone",
                    name: "phone",
                    label: "Phone",
                    pattern: pixTypeTransafeReg.PHONE,
                },
                {type: "input", name: "issuerCode", label: "CPFNumber", pattern: pixTypeTransafeReg.CPF},
            ],
            astropaydir: [
                {
                    type: "select",
                    name: "branchCode",
                    label: "BankCode",
                    options: [
                        {label: "CPF", value: "CPF"},
                        {label: "PHONE", value: "phone"},
                        {label: "EMAIL", value: "mail"},
                        {label: "RANDOM", value: "random_key"},
                    ],
                },
                {type: "input", name: "payeeAccountNo", label: "Account"},
                {type: "input", name: "payeeFirstName", label: "PayeeFirstName"},
                {type: "input", name: "payeeLastName", label: "PayeeLastName"},
                {
                    type: "phone",
                    name: "phone",
                    label: "PhoneAccount",
                    pattern: pixTypeTransafeReg.PHONE,
                    ifHidden: {field: "branchCode", value: "phone"},
                    extra: "payeeAccountNo",
                },
                {
                    type: "input",
                    name: "issuerCode",
                    label: "CPFNumber",
                    pattern: pixTypeTransafeReg.CPF,
                    ifHidden: {field: "branchCode", value: "CPF"},
                    extra: "payeeAccountNo",
                },
            ],
            betcatnew: [
                {
                    type: "select",
                    name: "branchCode",
                    label: "BankCode",
                    options: [
                        {label: "CPF", value: "CPF"},
                        {label: "EMAIL", value: "EMAIL"},
                        {label: "PHONE", value: "PHONE"},
                        {label: "CNPJ", value: "CNPJ"},
                    ],
                },
                {type: "input", name: "payeeName", label: "payeeName"},
                {type: "input", name: "payeeAccountNo", label: "CPFAccount", pattern: pixTypeTransafeReg.CPF, ifShow: {field: "branchCode", value: "CPF"}},
                {
                    type: "input",
                    name: "payeeAccountNo",
                    label: "EmailAccount",
                    pattern: pixTypeTransafeReg.EMAIL,
                    ifShow: {field: "branchCode", value: "EMAIL"},
                },
                {
                    type: "phone",
                    name: "payeeAccountNo",
                    label: "PhoneAccount",
                    pattern: pixTypeTransafeReg.PHONE,
                    ifShow: {field: "branchCode", value: "PHONE"},
                },
                {
                    type: "input",
                    name: "payeeAccountNo",
                    label: "CNPJAccount",
                    pattern: pixTypeTransafeReg.CNPJ,
                    ifShow: {field: "branchCode", value: "CNPJ"},
                },
                {
                    type: "input",
                    name: "issuerCode",
                    label: "CPFNumber",
                    pattern: pixTypeTransafeReg.CPF,
                    ifHidden: {field: "branchCode", value: "CPF"},
                    extra: "payeeAccountNo",
                },
            ],
            tustpay: [
                {
                    type: "select",
                    name: "branchCode",
                    label: "BankCode",
                    options: [
                        {label: "CPF", value: "CPF"},
                        {label: "CNPJ", value: "CNPJ"},
                        {label: "EMAIL", value: "EMAIL"},
                        {label: "PHONE", value: "PHONE"},
                    ],
                },
                {type: "input", name: "payeeName", label: "payeeName"},
                {
                    type: "input",
                    name: "payeeAccountNo",
                    label: "EmailAccount",
                    pattern: pixTypeTransafeReg.EMAIL,
                    ifShow: {field: "branchCode", value: "EMAIL"},
                },
                {
                    type: "phone",
                    name: "payeeAccountNo",
                    label: "PhoneAccount",
                    pattern: pixTypeTransafeReg.PHONE,
                    ifShow: {field: "branchCode", value: "PHONE"},
                },
                {type: "input", name: "payeeAccountNo", label: "CPFAccount", pattern: pixTypeTransafeReg.CPF, ifShow: {field: "branchCode", value: "CPF"}},
                {
                    type: "input",
                    name: "payeeAccountNo",
                    label: "CNPJAccount",
                    pattern: pixTypeTransafeReg.CNPJ,
                    ifShow: {field: "branchCode", value: "CNPJ"},
                },
                {
                    type: "input",
                    name: "issuerCode",
                    label: "CPFNumber",
                    pattern: pixTypeTransafeReg.CPF,
                    ifHidden: {field: "branchCode", value: "CPF"},
                    extra: "payeeAccountNo",
                },
            ],
            toppaybrl: [
                {
                    type: "select",
                    name: "branchCode",
                    label: "BankCode",
                    options: [
                        {label: "CPF", value: "CPF"},
                        {label: "EMAIL", value: "EMAIL"},
                        {label: "PHONE", value: "PHONE"},
                    ],
                },
                {
                    type: "input",
                    name: "payeeAccountNo",
                    label: "EmailAccount",
                    pattern: pixTypeTransafeReg.EMAIL,
                    ifShow: {field: "branchCode", value: "EMAIL"},
                },
                {
                    type: "phone",
                    name: "payeeAccountNo",
                    label: "PhoneAccount",
                    pattern: pixTypeTransafeReg.PHONE,
                    ifShow: {field: "branchCode", value: "PHONE"},
                },
                {type: "input", name: "payeeAccountNo", label: "CPFAccount", pattern: pixTypeTransafeReg.CPF, ifShow: {field: "branchCode", value: "CPF"}},
            ],
        },
    },
    {type: MoneyType.JPY, deposit: {}, withdraw: {jeton: [{type: "input", name: "payeeAccountNo", label: "Account"}]}},
    {
        type: MoneyType.CAD,
        deposit: {
            gigadat: [
                {
                    type: "input",
                    name: "mail",
                    label: "EmailAccount",
                    pattern: pixTypeTransafeReg.EMAIL,
                },
                {
                    type: "phone",
                    name: "phone",
                    label: "PhoneAccount",
                    pattern: pixTypeTransafeReg.PHONE,
                },
                {type: "input", name: "customerName", label: "UserName"},
            ],
        },
        withdraw: {
            astropay: [
                {
                    type: "select",
                    name: "issuerCode",
                    label: "BankCode",
                    options: [
                        {label: "Phone", value: "1"},
                        {label: "USER ID", value: "2"},
                    ],
                },
                {
                    type: "phone",
                    name: "payeeAccountNo",
                    label: "PhoneAccount",
                    pattern: pixTypeTransafeReg.PHONE,
                    ifShow: {field: "issuerCode", value: "1"},
                },
                {type: "input", name: "payeeAccountNo", label: "Account", ifShow: {field: "issuerCode", value: "2"}},
            ],
            gigadat: [
                {
                    type: "input",
                    name: "issuerCode",
                    label: "EmailAccount",
                    pattern: pixTypeTransafeReg.EMAIL,
                },
                {type: "input", name: "payeeName", label: "payeeName"},
                {
                    type: "phone",
                    name: "phone",
                    label: "Phone",
                    pattern: pixTypeTransafeReg.PHONE,
                },
            ],
            jeton: [{type: "input", name: "payeeAccountNo", label: "Account"}],
        },
    },
    {type: MoneyType.COP, deposit: {}, withdraw: {jeton: [{type: "input", name: "payeeAccountNo", label: "Account"}]}},
    {type: MoneyType.KRW, deposit: {}, withdraw: {jeton: [{type: "input", name: "payeeAccountNo", label: "Account"}]}},
    {
        type: MoneyType.IDR,
        deposit: {
            coverpay: [
                {
                    type: "phone",
                    name: "phone",
                    label: "PhoneAccount",
                    pattern: pixTypeTransafeReg.PHONE,
                },
            ],
        },
        withdraw: {
            toppay: [
                {type: "select", name: "issuerCode", label: "issuerCode", options: IDRtoppayOptions},
                {type: "input", name: "payeeName", label: "payeeName"},
                {type: "input", name: "payeeAccountNo", label: "payeeAccountNo"},
                {
                    type: "phone",
                    name: "phone",
                    label: "Phone",
                    pattern: pixTypeTransafeReg.PHONE,
                },
            ],
            coverpay: [
                {
                    type: "select",
                    name: "issuerCode",
                    label: "issuerCode",
                    options: [
                        {
                            label: "Bank Card",
                            value: "bankcard",
                        },
                        {
                            label: "E-wallet",
                            value: "ewallet",
                        },
                    ],
                },
                {
                    type: "select",
                    name: "branchCode",
                    label: "branchCode",
                    options: IDRcoverpayBranchCodeOptionsEWallet,
                    ifShow: {field: "issuerCode", value: "ewallet"},
                },
                {
                    type: "select",
                    name: "branchCode",
                    label: "branchCode",
                    options: IDRcoverpayBranchCodeOptionsCard,
                    ifShow: {field: "issuerCode", value: "bankcard"},
                },
                {type: "input", name: "payeeName", label: "payeeName"},
                {type: "input", name: "payeeAccountNo", label: "payeeAccountNo"},
                {
                    type: "phone",
                    name: "phone",
                    label: "Phone",
                    pattern: pixTypeTransafeReg.PHONE,
                },
            ],
        },
    },
    {
        type: MoneyType.INR,
        deposit: {},
        withdraw: {
            metagopay: [
                {
                    type: "select",
                    name: "branchCode",
                    label: "branchCode",
                    options: INRmetagopayOptions,
                    showSearch: true,
                },
                {type: "input", name: "payeeName", label: "payeeName"},
                {type: "input", name: "payeeAccountNo", label: "payeeAccountNo"},
                {
                    type: "input",
                    name: "issuerCode",
                    label: "IFSC",
                    pattern: pixTypeTransafeReg.IFSC,
                },
            ],
            easypay: [
                {
                    type: "select",
                    name: "branchCode",
                    label: "branchCode",
                    options: INRaepayOptions,
                    showSearch: true,
                },
                {type: "input", name: "payeeName", label: "payeeName"},
                {type: "input", name: "payeeAccountNo", label: "payeeAccountNo"},
                {
                    type: "input",
                    name: "issuerCode",
                    label: "IFSC",
                    pattern: pixTypeTransafeReg.IFSC,
                },
                {
                    type: "phone",
                    name: "phone",
                    label: "Phone",
                    pattern: pixTypeTransafeReg.PHONE,
                },
            ],
            oepay: [
                {
                    type: "select",
                    name: "payeeAccountType",
                    label: "payeeAccountType",
                    options: [{label: "BankCard", value: "0"}],
                },
                {type: "input", name: "payeeName", label: "payeeName"},
                {type: "input", name: "payeeAccountNo", label: "payeeAccountNo"},
                {
                    type: "input",
                    name: "remark",
                    label: "IFSC",
                    pattern: pixTypeTransafeReg.IFSC,
                },
                {
                    type: "input",
                    name: "email",
                    label: "EmailAccount",
                    pattern: pixTypeTransafeReg.EMAIL,
                },
                {
                    type: "phone",
                    name: "phone",
                    label: "Phone",
                    pattern: pixTypeTransafeReg.PHONE,
                },
            ],
            junepay: [
                {type: "input", name: "payeeName", label: "payeeName"},
                {type: "input", name: "payeeAccountNo", label: "payeeAccountNo"},
                {
                    type: "input",
                    name: "issuerCode",
                    label: "IFSC",
                    pattern: pixTypeTransafeReg.IFSC,
                },
                {
                    type: "phone",
                    name: "phone",
                    label: "Phone",
                    pattern: pixTypeTransafeReg.PHONE,
                },
                {
                    type: "input",
                    name: "branchCode",
                    label: "branchCode",
                },
            ],
        },
    },
    {
        type: MoneyType.PHP,
        deposit: {},
        withdraw: {
            bpay: [
                {type: "input", name: "payeeName", label: "payeeName"},
                {type: "input", name: "payeeAccountNo", label: "payeeAccountNo"},
            ],
        },
    },
    {
        type: MoneyType.MXN,
        deposit: {},
        withdraw: {
            bpay: [
                {type: "select", name: "issuerCode", label: "issuerCode", options: MXNbpayOptions},
                {type: "input", name: "payeeName", label: "payeeName"},
                {type: "input", name: "payeeAccountNo", label: "payeeAccountNo"},
            ],
            bilhub: [
                {type: "select", name: "issuerCode", label: "issuerCode", options: MXNbilhubOptions},
                {type: "input", name: "payeeName", label: "payeeName"},
                {type: "input", name: "payeeAccountNo", label: "payeeAccountNo", pattern: /^\d{16}(\d{2})?$/},
                {
                    type: "phone",
                    name: "phone",
                    label: "Phone",
                    pattern: pixTypeTransafeReg.PHONE,
                },
            ],
        },
    },
    {
        type: MoneyType.MYR,
        deposit: {},
        withdraw: {
            tarspay: [
                {type: "select", name: "branchCode", label: "branchCode", options: MYRtarspayOptions},
                {type: "input", name: "payeeName", label: "payeeName"},
                {type: "input", name: "payeeAccountNo", label: "payeeAccountNo"},
                {
                    type: "phone",
                    name: "phone",
                    label: "Phone",
                    pattern: pixTypeTransafeReg.PHONE,
                },
            ],
        },
    },
    {
        type: MoneyType.NGN,
        deposit: {},
        withdraw: {
            ngpay: [
                {type: "select", name: "issuerCode", label: "issuerCode", options: NGNngpayOptions},
                {type: "input", name: "payeeName", label: "payeeName"},
                {type: "input", name: "payeeAccountNo", label: "payeeAccountNo"},
            ],
            bpay: [
                {type: "select", name: "issuerCode", label: "issuerCode", options: NGNbpayOptions},
                {type: "input", name: "payeeName", label: "payeeName"},
                {type: "input", name: "payeeAccountNo", label: "payeeAccountNo"},
            ],
        },
    },
    {
        type: MoneyType.PEN,
        deposit: {},
        withdraw: {
            astropay: [
                {
                    type: "select",
                    name: "issuerCode",
                    label: "BankCode",
                    options: [
                        {label: "Phone", value: "1"},
                        {label: "USER ID", value: "2"},
                    ],
                },
                {
                    type: "phone",
                    name: "payeeAccountNo",
                    label: "PhoneAccount",
                    pattern: pixTypeTransafeReg.PHONE,
                    ifShow: {field: "issuerCode", value: "1"},
                },
                {type: "input", name: "payeeAccountNo", label: "Account", ifShow: {field: "issuerCode", value: "2"}},
            ],
        },
    },
    {
        type: MoneyType.VND,
        deposit: {},
        withdraw: {
            vndpay: [
                {
                    type: "select",
                    name: "branchCode",
                    label: "BankCode",
                    options: VNDvndpayOptions,
                },
                {type: "input", name: "payeeName", label: "payeeName"},
                {type: "input", name: "payeeAccountNo", label: "payeeAccountNo"},
                {type: "input", name: "issuerCode", label: "BankName"},
            ],
        },
    },
    {
        type: MoneyType.ZAR,
        deposit: {},
        withdraw: {
            ppay: [
                {
                    type: "select",
                    name: "branchCode",
                    label: "BankCode",
                    options: ZARppayOptions,
                },
                {type: "input", name: "payeeName", label: "payeeName"},
                {type: "input", name: "payeeAccountNo", label: "payeeAccountNo"},
            ],
            bpay: [
                {type: "select", name: "issuerCode", label: "issuerCode", options: ZARbpayOptions},
                {type: "input", name: "payeeName", label: "payeeName"},
                {type: "input", name: "payeeAccountNo", label: "payeeAccountNo"},
            ],
        },
    },
    {
        type: MoneyType.SGD,
        deposit: {},
        withdraw: {
            bankcardpay: [
                {type: "select", name: "issuerCode", label: "issuerCode", options: SGDbankcardOptions},
                {type: "input", name: "payeeName", label: "payeeName"},
                {type: "input", name: "payeeAccountNo", label: "payeeAccountNo"},
            ],
        },
    },
];
